<template>
  <div>
    <el-breadcrumb class="navcss" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
      <el-breadcrumb-item>共有网络平面</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-button type="primary" @click="adddevice"
                   v-if="btnInList('idc_pubNetMan','idc_pubNetMan_add')">新增共有网络平面</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column align="center" prop="netPlaneName" label="名称" width="180"></el-table-column>
      <el-table-column align="center" prop="remark" label="描述"></el-table-column>
      <el-table-column align="center" label="操作" width="600">
        <template v-slot="{row}">
          <el-button size="mini" type="primary" @click="setAcceassNetPlane(row)"
                     v-if="btnInList('idc_pubNetMan','idc_pubNetMan_setAccessNetPlane')">设置可访问网络平面</el-button>
          <el-button size="mini" type="primary" @click="viewnetplane(row)"
                     v-if="btnInList('idc_pubNetMan','idc_pubNetMan_topo')">查看网络拓扑</el-button>
          <el-button size="mini" type="primary" @click="edit(row)"
                     v-if="btnInList('idc_pubNetMan','idc_pubNetMan_edit')">编辑</el-button>
          <el-button size="mini" type="danger" @click="delConfirm(row.id)"
                     v-if="btnInList('idc_pubNetMan','idc_pubNetMan_del')">删除</el-button>
          <el-button size="mini" type="primary" @click="ipView(row)"
                     v-if="btnInList('idc_pubNetMan','idc_pubNetMan_ipView')">IP地址查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

<!--    新增共有网络平面-->
    <el-dialog
      :title="dialogTitle"
      :visible="netPlaneAdd"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <el-form label-position="left" style="margin-left: 20px;width: 300px;" :model="formData" ref="formData" label-width="60px" :rules="rules">
        <el-form-item label="名 称" prop="netPlaneName">
          <el-input v-model="formData.netPlaneName" placeholder="请输入名称" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="描 述">
          <el-input v-model="formData.remark" placeholder="请输入描述" style="width: 250px"></el-input>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="confirm('formData')">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="'IP地址查看'"
      :visible="netPlaneIpVisible"
      @close="close()"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="70%">
      <el-table :data="ipTableData" style="width: 100%">
        <el-table-column
          type="index"
          width="50"></el-table-column>
        <el-table-column align="center" prop="id" label="ID"></el-table-column>
        <el-table-column align="center" prop="ipStr" label="IP 地址" width="180"></el-table-column>
        <el-table-column align="center" prop="ispName" label="ISP 信息"></el-table-column>
        <el-table-column align="center" prop="mappingIp" label="映射内网IP"></el-table-column>
        <el-table-column align="center" prop="netPlaneName" label="网络平面"></el-table-column>
        <el-table-column align="center" label="映射模式">
          <template slot-scope="scope">
            {{convertModelData(scope.row.relationType)}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 设置可访问网络平面-->
    <el-dialog
      :title="'设置可访问网络平面'"
      :visible="contactnetplane"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%">
      <span  style="position:absolute; right:150px; top:40px;">
        <el-button v-show="isshow" size="mini" type="primary" @click="skip">跳转到私有网络平面</el-button>
      </span>
      <el-row>
        <el-col :span="18">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="私有网络平面" name="private">
              <el-table
                ref="priNetPlaneTable"
                :data="privateTableData"
                tooltip-effect="dark" @selection-change="handleSelectionChangePrivateChoice"
                style="width: 100%">
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column align="center" prop="id" width="60" label="ID"></el-table-column>
                <el-table-column align="center" property="netPlaneName" label="网络平面名称" ></el-table-column>
                <el-table-column align="center" property="idcName" label="所属IDC机房"></el-table-column>
                <el-table-column align="center" property="remark" label="描述"></el-table-column>
                <el-table-column align="center" label="是否直接访问" >
                  <template v-slot="{row}">
                    <el-radio-group v-model="row.isDirectAccess" @change="directAccesschange(row)" size="mini">
                      <el-radio border :label="1" style="margin-right: 1px;">是</el-radio>
                      <el-radio border :label="0" style="margin-right: 1px;">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="共有网络平面" name="public">
              <el-table
                ref="pubNetPlaneTable"
                :data="pubTableData"
                tooltip-effect="dark" @selection-change="handleSelectionChangeChoice"
                style="width: 100%">
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column align="center" prop="id" label="ID"></el-table-column>
                <el-table-column align="center" property="netPlaneName" label="网络平面名称" ></el-table-column>
                <el-table-column align="center" property="remark" label="描述"></el-table-column>
                <el-table-column align="center" label="是否直接访问" >
                  <template v-slot="{row}">
                    <el-radio-group v-model="row.isDirectAccess" @change="directAccesschange(row)" size="mini">
                      <el-radio border :label="1" style="margin-right: 1px;">是</el-radio>
                      <el-radio border :label="0" style="margin-right: 1px;">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-row style="text-align: center; margin-top: 20px">
              <el-button type="primary" @click="saveAccessNetPlane()">提 交</el-button>
              <el-button @click="cancelAccessNetPlane()">取 消</el-button>
            </el-row>
          </el-tabs>
        </el-col>
        <el-col :span="6">
          <div style="display:inline-block;position: absolute;top: 15px;margin-left: 20px;">已选网络平面：</div>
          <transition-group name="right-fade-in" tag="div" class="table_border">
            <div v-for="(item, index) in contentMultipleSelection " :key="index">
                <span class="table_right_name">
                  <span class="span" v-if="item.id >= 1000" style="color: #67C23A;">{{item.netPlaneName}}</span>
                  <span class="span" v-else style="color:#E6A23C" >{{item.netPlaneName}}</span>
                  <i class="el-icon-minus shez" @click="remove_multiple_selected_content(item.netPlaneName+item.id, index)"></i>
                </span>
            </div>
          </transition-group>
        </el-col>
      </el-row>
    </el-dialog>
<!--    跳转-->
    <el-dialog
      :title="'请选择跳转到哪个IDC机房的私有网络平面'"
      :visible="skipselect"
      @close="close()"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <el-table :data="idcData" style="width: 100%">
        <el-table-column
          type="index"
          width="40"></el-table-column>
        <el-table-column align="center" prop="id" label="ID" width="130"></el-table-column>
        <el-table-column align="center" prop="idcName" label="IDC名称"></el-table-column>
        <el-table-column align="center" property="operate" label="操作">
          <template v-slot="{row}">
            <el-button size="mini" type="primary" @click="jump(row.id)">跳转</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <jtopo-net-plane v-if="showViewNetPlane" :showViewNetPlane="showViewNetPlane" :viewNetPlaneItme="viewNetPlaneItme"
                     @editCallback="editCallback"/>
  </div>
</template>

<script>
  import JtopoNetPlane from '../privatenetplane/JtopoNetPlane'
  import {mapMutations, mapState} from "vuex";
  export default {
    name: "PubNetPlane",
    components: {JtopoNetPlane},
    data() {
      return {
        isshow:true,
        dialogTitle: "",
        id: null,
        showViewNetPlane: false,
        viewNetPlaneItme:{},
        netPlaneIpId: null,
        netPlaneAdd: false, //新增窗口
        netPlaneIpVisible: false,
        contactnetplane: false,
        skipselect:false,
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        activeName: "private",
        tableData: [],
        idcData:[],
        privateTableData: [],
        pubTableData: [],
        contentMultipleSelection: [], // 添加内容时已选中的内容
        currentPageCheckedIndexs: [], // 当前页共用选中的index数组
        currentPageCheckedPrivateIndexs: [], //当前页私用选中的index数组
        ipTableData: [],
        formData: {
          netPlaneName: "",
          remark: ""
        },
        rules: {
          netPlaneName: [
            {required: true, message: '请输入私有网络平面名称', trigger: 'blur'}
          ],
        }
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      btnInList() {
        return (name, childName) => {
          let btn = this.listOperations.filter(op => op.name.includes(name));
          if(btn && btn.length>0){
            if (!childName) {
              return btn.length > 0
            } else {
              return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
            }
          }
        }
      },
    },
    methods: {
      ...mapMutations(['getListOperations']),
      handleClick(){
        this.isshow=!this.isshow
      },
      editCallback(){
        this.showViewNetPlane = false
      },
      delConfirm(id){
        this.$confirm('您确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(id)
        }).catch((err) => {
          console.log(err)
        });
      },
      del(id){
        let data = {
          id: id
        }
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netplane/del', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.initNetPlaneList();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      jump(id){
        this.$router.push({
              path: 'privatenetplane',
              name: 'privatenetplane',
              params: {
                idcId: id
              }
            })
      },
      skip() {
        this.skipselect = true;
        var data = {
          'pageNo': this.currentPage,
          'pageSize': this.pageSize,
          'condition': this.condition,
        };
        var _this = this;

        _this.idcData = []
        this.$axios.post(this.baseUrl3 + 'management3/idc/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.idcData = data.idcList;
              _this.totalElement = data.total;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      convertModelData( type ){
        if( type == 0){
          return ""
        }else if(type == 1){
          return "NAT"
        }else {
          return "NAPT"
        }
      },
      adddevice() {
        this.id = null;
        this.dialogTitle = '新增共有网络平面';
        this.formData.netPlaneName = "";
        this.formData.remark = "";
        this.netPlaneAdd = true
      },
      resetForm() {
        this.netPlaneAdd = false
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.initNetPlaneList()
      },
      handleCurrentChange( val ) {
        this.currentPage = val
        this.initNetPlaneList()
      },
      viewnetplane( item ) {
        this.showViewNetPlane = true;
        this.viewNetPlaneItme = item;
      },
      setAcceassNetPlane( item ){
        this.netPlaneIpId = item.id;
        this.initSetNetPlaneList();

        this.contactnetplane = true;
      },
      close(){
        this.netPlaneIpVisible = false;
        this.skipselect = false
      },
      edit( item ) {
        this.id = item.id;
        this.formData.netPlaneName = item.netPlaneName;
        this.formData.remark = item.remark;
        this.dialogTitle = '编辑共有网络平面';
        this.netPlaneAdd = true
      },
      ipView(item) {
        this.netPlaneIpId = item.id;
        this.initNetPlaneIpList();
        this.netPlaneIpVisible = true;
      },
      handleSelectionChangePrivateChoice(contents) {
        let newIndexs = [];
        let _this = this;
        // 判断已选中列表中是否已经有contents, 没有就加入
        for (let content of contents) {
          let index = this.contentMultipleSelection.findIndex(
            item => item.netPlaneName + "" + item.id === content.netPlaneName + "" + content.id
          );
          newIndexs.push(_this.privateTableData.findIndex(val => val.netPlaneName + "" + val.id === content.netPlaneName + "" + content.id));
          if (index === -1) {
            this.contentMultipleSelection.unshift(content);
          }
        }

        // 新旧对比，如果旧的有的新的没有，那么就删除这个
        for (let old of _this.currentPageCheckedPrivateIndexs) {
          if (newIndexs.findIndex(newIndex => newIndex === old) === -1) {
            let index = _this.contentMultipleSelection.findIndex(
              item => item.netPlaneName + "" + item.id === _this.privateTableData[old].netPlaneName + "" + _this.privateTableData[old].id
            );
            if (index !== -1) {
              _this.contentMultipleSelection.splice(index, 1);
            }
          }
        }
        _this.currentPageCheckedPrivateIndexs = newIndexs;
  },
      directAccesschange( row ){
        this.contentMultipleSelection.forEach(e =>{
          if(e.netPlaneName + "" + e.id === row.netPlaneName + "" + row.id){
            e.isDirectAccess = row.isDirectAccess
          }
        })
      },
      handleSelectionChangeChoice(contents) {
        let newIndexs = [];

        // 判断已选中列表中是否已经有contents, 没有就加入
        for (let content of contents) {
          let index = this.contentMultipleSelection.findIndex(
            item => item.netPlaneName + "" + item.id === content.netPlaneName + "" + content.id
          );
          newIndexs.push(this.pubTableData.findIndex(val => val.netPlaneName + "" + val.id === content.netPlaneName + "" + content.id));
          if (index === -1) {
            this.contentMultipleSelection.unshift(content);
          }
        }

        let _this = this;
        // 新旧对比，如果旧的有的新的没有，那么就删除这个
        for (let old of _this.currentPageCheckedIndexs) {
          if (newIndexs.findIndex(newIndex => newIndex === old) === -1) {
            let index = _this.contentMultipleSelection.findIndex(
              item => item.netPlaneName + "" + item.id === _this.pubTableData[old].netPlaneName + "" + _this.pubTableData[old].id
            );
            if (index !== -1) {
              _this.contentMultipleSelection.splice(index, 1);
            }
          }
        }
        _this.currentPageCheckedIndexs = newIndexs;
      },
      remove_multiple_selected_content(netPlaneName, index) {
        this.contentMultipleSelection.splice(index, 1);
        // 如果表格中有要删除的这个数据，取消checkbox

        let glIndex = this.pubTableData.findIndex(val => val.netPlaneName + "" + val.id === netPlaneName);
        if (glIndex !== -1){
          this.$refs.pubNetPlaneTable.toggleRowSelection(this.pubTableData[glIndex], false);
        }

        let glprivateIndex = this.privateTableData.findIndex(val => val.netPlaneName+ "" + val.id === netPlaneName);
        if (glprivateIndex !== -1){
          this.$refs.priNetPlaneTable.toggleRowSelection(this.privateTableData[glprivateIndex], false);
        }


      },
      cancelAccessNetPlane(){
        this.contactnetplane = false;
      },
      saveAccessNetPlane(){
        let netPlaneIds = []
        for (let i = 0; i < this.contentMultipleSelection.length; i++) {
          let obj={
            netId: this.contentMultipleSelection[i].id,
            isDirectAccess: this.contentMultipleSelection[i].isDirectAccess
          };
          netPlaneIds.push(obj);
        }
        let data = {
          netPlaneId: this.netPlaneIpId,
          accessNetInfo:netPlaneIds,
        };
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55, 55, 55, 0.4)'
        });
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netplane/bind', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.contactnetplane = false;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              loading.close();
            }, 2000);
          })
      },
      getAccessNetPlaneById( id ){
        let data = {
          netPlaneId: id
        }
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netplane/bindlist', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if(data.netPlaneList){
                for(let i=0;i<data.netPlaneList.length;i++){
                  _this.contentMultipleSelection.push(data.netPlaneList[i]);
                }
              }
              if(data.wanNetPlaneList) {
                for (let i = 0; i < data.wanNetPlaneList.length; i++) {
                  _this.contentMultipleSelection.push(data.wanNetPlaneList[i]);
                }
              }
                _this.$nextTick(() => {
                  if(_this.privateTableData && _this.privateTableData.length >0 ){
                  _this.privateTableData.forEach((data, index) => {
                    if (
                      data &&
                      _this.contentMultipleSelection.findIndex(
                      item => item.netPlaneName + "" + item.id === data.netPlaneName + "" + data.id
                      ) !== -1
                    ) {
                      let idx = _this.contentMultipleSelection.findIndex(
                        item => item.netPlaneName + "" + item.id === data.netPlaneName + "" + data.id
                      )
                      data.isDirectAccess = _this.contentMultipleSelection[idx].isDirectAccess
                      _this.$refs.priNetPlaneTable.toggleRowSelection(
                        _this.privateTableData[index],
                        true
                      );
                    }
                  });
                  }
                  if(_this.pubTableData && _this.pubTableData.length >0 ){
                  _this.pubTableData.forEach((data, index) => {
                    if (
                      data &&
                      _this.contentMultipleSelection.findIndex(
                        item => item.netPlaneName + "" + item.id === data.netPlaneName + "" + data.id
                      ) !== -1
                    ) {
                      let idx = _this.contentMultipleSelection.findIndex(
                        item => item.netPlaneName + "" + item.id === data.netPlaneName + "" + data.id
                      )
                      data.isDirectAccess = _this.contentMultipleSelection[idx].isDirectAccess
                      _this.$refs.pubNetPlaneTable.toggleRowSelection(
                        _this.pubTableData[index],
                        true
                      );
                    }
                  });
                  }
                });
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initNetPlaneList() {
        var data = {
          'pageNo': this.currentPage,
          'pageSize': this.pageSize,
        };
        let _this = this;
        _this.tableData = [];

        this.$axios.post(this.baseUrl3 + 'management3/netplanepub/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.tableData = data.netPlaneList;
              _this.totalElement = data.total
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initSetNetPlaneList() {
        let _this = this;
        let paramData = {
          type: 1,
          netPlaneId: this.netPlaneIpId
        }
        _this.pubTableData = [];
        _this.privateTableData = [];
        _this.currentPageCheckedPrivateIndexs = [];
        _this.contentMultipleSelection = [];
        _this.currentPageCheckedIndexs = [];
        this.$axios.post(this.baseUrl3 + 'management3/netplane/list', paramData)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if(data.wanNetPlaneList && data.wanNetPlaneList.length >0){
                data.wanNetPlaneList.forEach(e =>{
                  e.isDirectAccess = 1
                })
                _this.pubTableData = data.wanNetPlaneList;
              }
              if(data.netPlaneList && data.netPlaneList.length>0 ){
                data.netPlaneList.forEach(e => {
                  e.isDirectAccess = 1
                })
                _this.privateTableData = data.netPlaneList;
              }
              _this.getAccessNetPlaneById(_this.netPlaneIpId)
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initNetPlaneIpList() {
        let data = {
          pageNo: 1,
          pageSize: 100000000,
          netPlaneId: this.netPlaneIpId,
          type: 1
        }
        let _this = this;
        _this.ipTableData = []

        this.$axios.post(this.baseUrl3 + 'management3/netip/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.ipTableData = data.IpList;

            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      confirm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveNetPlane();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      saveNetPlane() {
        let data = {
          netPlaneName: this.formData.netPlaneName,
          remark: this.formData.remark,
          type: 1,
          id: this.id
        }
        let _this = this;
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55,0.4)'
        });
        this.$axios.post(this.baseUrl3 + 'management3/netplane/update', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.initNetPlaneList();
              _this.resetForm(true);
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              loading.close();
            }, 2000);
            // loading.close();
          })
      }
    },

    created() {
      this.getListOperations('idclist')
      if (!this.currentMenu) {
        return
      }
      this.initNetPlaneList();
    }
  }
</script>

<style scoped lang="less">
  .el-loading-spinner {
    background-image:url('../../../assets/loading1.svg');
    background-size:63px 100px;
    background-repeat: no-repeat;
    height:30%;
    background-position:center;
    top:200px;
  }
  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
  .navcss {
    font-size: 17px;
    margin-bottom: 15px;
  }

  .table_border {
    overflow-y: auto;
  // height: 390px;
    overflow-x: hidden;
    margin-top: 40px;
    margin-left: 20px;

  .table_right_name {
    display: inline-block;
    width: 93%;
    border: 1px solid #eeeeee;
    padding: 10px 10px;

  .span {
    width: 90%;
    cursor: pointer;
    display: inline-block;
    text-overflow: ellipsis;
    /*display: -webkit-box;*/
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    float: left;
  }
  }

  .shez {
    color: #fff;
    background: #f00;
    padding: 2px;
    border-radius: 50%;

  &:hover {
     cursor: pointer;
   }

  }

  }
</style>
